import React from 'react';
import PropTypes from 'prop-types';

import BemClass from '@upsales/components/Utils/bemClass';

import './CriteriaWrapper.scss';
import { Icon, Button, Tooltip, Heading, BodyText } from '@upsales/components';
import t from 'Components/Helpers/translate';

const CriteriaWrapper = props => {
	const { className, onClick, onRemove, children, lang, locked, type, showEntity, customFieldTooltip } = props;
	const classes = new BemClass('CriteriaWrapper', className);

	let lastCol;
	if (onRemove && !locked) {
		lastCol = (
			<td className={classes.elem('last-col').b()}>
				<Tooltip title={lang.remove} position="left">
					<Button
						type="link"
						color="grey"
						className={classes.elem('remove').b()}
						onClick={e => e.stopPropagation() || onRemove()}
					>
						<Icon name="times-circle" />
					</Button>
				</Tooltip>
			</td>
		);
	} else if (locked) {
		lastCol = (
			<td className={classes.elem('last-col').b()}>
				<Tooltip
					title={t(type === 'criteria' ? 'default.journeyCriteriaLocked' : 'default.journeyActionLocked')}
					position="left"
				>
					<Icon className={classes.elem('lock').b()} name="lock" />
				</Tooltip>
			</td>
		);
	} else {
		lastCol = <td />;
	}

	return (
		<tr
			className={classes.mod({ 'has-on-click': !locked && onClick, locked }).b()}
			onClick={locked ? null : onClick}
		>
			<td className={classes.elem('title-col').b()}>
				<div className={classes.elem('title-container')}>
					<div>
						<Tooltip
							disabled={!customFieldTooltip}
							title={`${lang.title}${customFieldTooltip ? '\n\n' + customFieldTooltip : ''}`}
							position="right"
						>
							<Heading
								className={classes.elem('title').b()}
								size="sm"
								ellipsis
								ellipsisDisableTooltip={!!customFieldTooltip}
								ellipsisProps={{
									position: 'right'
								}}
							>
								{props.icon ? <Icon name={props.icon} spacing="pr1" /> : null}
								{lang.title}
							</Heading>
						</Tooltip>
						{showEntity ? (
							<BodyText className={classes.elem('entity').b()} color="neutral-600" ellipsis>
								{lang.entity}
							</BodyText>
						) : null}
					</div>
					{lang.tooltip ? (
						<Tooltip title={lang.tooltip} position="right">
							<Icon name="question-circle" spacing="ml3" color="neutral-700"></Icon>
						</Tooltip>
					) : null}
				</div>
			</td>
			<td className={classes.elem('table-col').b()}>{children}</td>
			{lastCol}
		</tr>
	);
};

CriteriaWrapper.propTypes = {
	className: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	lang: PropTypes.object.isRequired,
	onClick: PropTypes.func,
	onRemove: PropTypes.func,
	locked: PropTypes.bool,
	type: PropTypes.oneOf(['criteria', 'action']),
	showEntity: PropTypes.bool,
	icon: PropTypes.string
};

export default CriteriaWrapper;
